import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NgbTypeahead,
  NgbTypeaheadModule,
  NgbTypeaheadSelectItemEvent,
} from '@ng-bootstrap/ng-bootstrap';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  merge,
  Observable,
  Subject,
} from 'rxjs';

@Component({
  selector: 'app-configuration-typeahead',
  imports: [NgbTypeaheadModule, ReactiveFormsModule, FormsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './configuration-typeahead.component.html',
})
export class ConfigurationTypeaheadComponent {
  @Input({ required: true }) placeholder: string;
  @Input({ required: true }) items: any[];
  @Input() control: FormControl<string>;
  @Input() dataCy: string;
  @Input() displayPropertyName = 'name';
  @Input() disabled: boolean = false;

  @Output() selected = new EventEmitter<string>();

  @ViewChild('instance', { static: true }) instance: NgbTypeahead;

  protected focus$ = new Subject<string>();
  protected click$ = new Subject<string>();

  protected search = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(
      debounceTime(500),
      distinctUntilChanged()
    );
    const clicksWithClosedPopup$ = this.click$.pipe(
      filter(() => (this.instance ? !this.instance.isPopupOpen() : false))
    );
    const inputFocus$ = this.focus$;

    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map((term) =>
        this.items.filter(
          (v) =>
            v[this.displayPropertyName]
              .toLowerCase()
              .indexOf(term.toLowerCase()) > -1
        )
      )
    );
  };

  protected selectItem(selectItemEvent: NgbTypeaheadSelectItemEvent) {
    this.selected.emit(selectItemEvent.item.id);

    if (this.control) {
      this.control.setValue(selectItemEvent.item.id);
    }
  }

  inputFormatter = (item: any) => '';
}
